export enum PlanStyle {
  PERSONAL = 'PERSONAL',
  FIXED = 'FIXED',
}
